import { useEffect, useState } from 'react';
import { FreeShippingsProps, freeShippingMessageTitle } from './types';
import ToFreeShippings from '../ToFreeShippings';
import clsx from 'clsx';
import config from 'config-base';
import styles from './FreeShippings.module.css';
import currencyFormatting from '@package/utils/src/currencyFormatting';
import { SubOrder } from '@package/core/src/shoppingCart/types';

const FreeShippings = ({ cartData }: FreeShippingsProps) => {
  const [freeShippingContent, setFreeShippingContent] = useState<string>('');
  const [multipleSellers, setMultipleSellers] = useState<boolean>(() => {
    const sellers = cartData?.subOrders.filter(
      (order: SubOrder) => order.vendorId != 0 && order.vendorShipping.freeShippingMessage,
    );
    return sellers ? sellers.length > 1 : false;
  });

  const handleFreeShippingMessages = () => {
    let freeShippingMessages: any = [];
    cartData?.subOrders.map((order) => {
      if(order.vendorId !== 0) {
        freeShippingMessages.push(
          `<h3 style="margin-bottom: 0;">${
            order.vendor
          }</h3><ul style="margin-top: 0; padding-left: 20px;"><li>Orders over: ${currencyFormatting(
            order.vendorShipping.freeShippingAmountMin,
          )}</li><li>Shipping to: ${order.vendorShipping.freeShippingZone}</li></ul>`,
        );
      }
    });
    if (freeShippingMessages) {
      setMultipleSellers(freeShippingMessages.length > 1);
      freeShippingMessages = [freeShippingMessageTitle, ...freeShippingMessages];
      setFreeShippingContent(freeShippingMessages.join(''));
    }
  };

  useEffect(() => {
    handleFreeShippingMessages();
  }, [cartData]);

  return (
    <div
      className={clsx(styles.freeShippingContainer, {
        [styles.freeShippingContainerPY]: config.brandCode === '0',
      })}
    >
      {multipleSellers && (
        <ToFreeShippings
          key="free-shipping-message"
          id="free-shipping-message-multy"
          freeShippingContent={freeShippingContent}
          freeShippingMessage={'<strong>FREE Shipping</strong> is available from multiple sellers!'}
          linkTitle="View offers"
        />
      )}

      {cartData.subOrders.map((order) => {
        return (
          order.vendorShipping.freeShippingMessage &&
          (!multipleSellers || order.vendorId === 0) && (
            <ToFreeShippings
              key={order.orderId}
              id="free-shipping-message"
              freeShippingContent={order.vendorId !== 0 ? freeShippingContent : ''}
              freeShippingMessage={order.vendorShipping.freeShippingMessage}
              subTitle={order.vendorId === 0 ? 'Contiguous USA. Cannot be combined with most coupons' : ''}
              linkTitle="Details"
            />
          )
        );
      })}
    </div>
  );
};

export default FreeShippings;
